export const koreanRestaurantMenuTypes = [
  { id: "korean", label: "한식", shortLabel: "한식" },
  { id: "chinese", label: "중식당", shortLabel: "중식당" },
  { id: "bbq", label: "BBQ·고기", shortLabel: "BBQ" },
  { id: "chicken", label: "치킨", shortLabel: "치킨" },
  { id: "bunsik", label: "분식", shortLabel: "분식" },
  { id: "soup", label: "국밥·탕·찌개", shortLabel: "국밥·탕" },
  { id: "noodles", label: "면·냉면", shortLabel: "면·냉면" },
  { id: "seafood", label: "해산물·회", shortLabel: "해산물" },
  { id: "buffet", label: "뷔페", shortLabel: "뷔페" },
  { id: "cafe-dessert", label: "카페·디저트", shortLabel: "카페" },
  { id: "pub", label: "주점·포차", shortLabel: "주점" },
] as const;

export type KoreanRestaurantMenuType =
  (typeof koreanRestaurantMenuTypes)[number]["id"];

const koreanRestaurantMenuTypeIds = new Set<string>(
  koreanRestaurantMenuTypes.map((type) => type.id),
);

export function isKoreanRestaurantMenuType(
  value: string,
): value is KoreanRestaurantMenuType {
  return koreanRestaurantMenuTypeIds.has(value);
}

export function normalizeKoreanRestaurantMenuTypes(
  values: readonly string[] | null | undefined,
): KoreanRestaurantMenuType[] {
  return Array.from(
    new Set((values || []).filter(isKoreanRestaurantMenuType)),
  );
}
